import React from 'react';
import { formStyles } from '../utils/formStyles';
import { useTranslation } from 'react-i18next';

export function ColorFormFields({ formData, handleChange, handleSubmit, isEdit = false, onCancel }) {
  const { t } = useTranslation();

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="relative">
        <input
          type="text"
          id="name_de"
          name="name_de"
          value={formData.name_de}
          onChange={handleChange}
          className={formStyles.input}
          required
        />
        <label htmlFor="name_de" className={`${formStyles.label} ${formData.name_de ? formStyles.labelActive : ''}`}>
          {t('colorform.name_de')}
        </label>
      </div>
      
      <div className="relative">
        <input
          type="text"
          id="name_en"
          name="name_en"
          value={formData.name_en}
          onChange={handleChange}
          className={formStyles.input}
          required
        />
        <label htmlFor="name_en" className={`${formStyles.label} ${formData.name_en ? formStyles.labelActive : ''}`}>
          {t('colorform.name_en')}
        </label>
      </div>
      
      <div className="relative">
        <input
          type="color"
          id="color_code"
          name="color_code"
          value={formData.color_code}
          onChange={handleChange}
          className="w-full h-12 rounded-lg border border-gray-300 dark:border-zinc-600 cursor-pointer"
          required
        />
        <label htmlFor="color_code" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          {t('colorform.color_code')}
        </label>
      </div>
      
      <div className="flex justify-end gap-4">
        <button type="submit" className={formStyles.button}>
          {isEdit ? t('colorform.update') : t('colorform.create')}
        </button>
        {isEdit && onCancel && (
          <button type="button" onClick={onCancel} className="px-4 py-2 bg-gray-300 dark:bg-zinc-700 rounded text-gray-800 dark:text-gray-200">
            {t('colorform.cancel')}
          </button>
        )}
      </div>
    </form>
  );
}